module.exports = __webpack_public_path__ + "img/account-type.3b62f31c.png";